import { Formik } from "formik";
import React, { useState } from "react";
import Modal from "react-modal";
import { Link, useHistory, useLocation } from "react-router-dom";
import Button from "_shared/components/Button/Button";
import InputField from "../../_shared/components/InputField/InputField";
import { withAuth } from "../../_shared/contexts/AuthContext";
import { useModal } from "../../_shared/contexts/ModalContext";
import "../reset/Reset.scss";

Modal.setAppElement("#root");

interface Props {
  resetPassword: (
    username: string,
    code: string,
    password: string,
  ) => Promise<void>;
}

const initialValues = { password: "", confirmPassword: "" };

export const SetPassword: React.FC<Props> = ({ resetPassword }) => {
  const history = useHistory();
  const [username, setUsername] = useState("");
  const [code, setCode] = useState("");
  const location = useLocation();
  const { onErrorMsg, onSuccessMsg } = useModal();

  React.useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const urlUsername = urlParams.get("username");
    const urlCode = urlParams.get("code");
    if (!urlUsername || !urlCode) {
      onErrorMsg("A valid reset code is required", () => history.push("/"));
      return;
    }
    setUsername(urlUsername);
    setCode(urlCode);
  }, [history, location.search, onErrorMsg]);

  async function handleSubmit({
    password,
    confirmPassword,
  }: typeof initialValues) {
    // TODO: deal with validation using formik validation and a modal context
    if (!password || password.length === 0) {
      return onErrorMsg("Please enter your new password");
    } else if (!confirmPassword) {
      return onErrorMsg("Please confirm your new password");
    } else if (password !== confirmPassword) {
      return onErrorMsg("Make sure your passwords match");
    } else if (password.length < 6) {
      return onErrorMsg(
        "Make sure your new password is at least 6 characters long",
      );
    }

    try {
      if (!code || !password) return;
      await resetPassword(username, code, password);
      onSuccessMsg(
        `You've successfully changed your password. You may now login.`,
        () => history.push("/login"),
      );
    } catch (err) {
      onErrorMsg(`We couldn't reset your password.`);
      console.error(err);
    }
  }

  return (
    <div id="reset-page">
      <div className="card">
        <div>
          <h2 className="forgot-password-text">Reset Password</h2>
          <Formik
            initialValues={{ password: "", confirmPassword: "" }}
            onSubmit={handleSubmit}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <div className="input-container">
                  <InputField
                    name="password"
                    label="New password"
                    type="password"
                  />
                </div>
                <div className="input-container">
                  <InputField
                    name="confirmPassword"
                    label="Confirm password"
                    type="password"
                  />
                </div>
                <Button type="submit" fullWidth>
                  Reset Password
                </Button>
              </form>
            )}
          </Formik>
          <div className="dont-have-account-text">
            <div className="justify-center">Don't have an account yet?</div>
            <Link to="/signup" className="signup-link justify-center">
              SIGN UP
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withAuth(SetPassword);
